import StoredLayout from '../../layouts/StoredLayout'
import Lists from './Lists'
export default StoredLayout(Lists)



// WEBPACK FOOTER //
// ./src/ui-elements/lists/index.js